import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {
  @Input() text: string | undefined;
  @Input() title: string | undefined;
  @Input() confirmButtonTitle: string | undefined;
  @Input() dismissButtonTitle: string | undefined;
  @Input() dispayTextArea: boolean = false;
  @Input() textAreaPlaceholder: string = "";
  @Output() textAreInputEvent: EventEmitter<string> = new EventEmitter<string>();

  textAreaContent: string = "";
  constructor(public activeModal: NgbActiveModal) {
  }

  textAreaInput(content: string) {
    this.textAreaContent = content;
    this.textAreInputEvent.emit(content);
  }

  onConfirmClick(): void {
    this.activeModal.close();
  }

  onDismissClick(): void {
    /// https://github.com/ng-bootstrap/ng-bootstrap/issues/3721
    this.activeModal.dismiss();
  }
}

